import React, { useEffect, useState } from "react";
import SelectField from "../../molecules/SelectField/SelectField";
import { getThemeField } from "../../molecules/SettingsCard/helper";
import { useTranslation } from "react-i18next";

export type ThemeType = "light" | "dark";

interface ThemeSelectProps {
  theme?: string;
  onThemeChange?: (value: ThemeType) => void;
}

const ThemeSelect = (props: ThemeSelectProps) => {
  const { theme, onThemeChange } = props;

  const { t } = useTranslation();

  const [currentTheme, setCurrentTheme] = useState(theme ?? "light");

  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches &&
      localStorage.getItem("theme") === null
    ) {
      setCurrentTheme("dark");
      localStorage.setItem("theme", "dark");
    }
  }, []);

  const handleChangeTheme = (value: string) => {
    if (value === "light" || value === "dark") {
      document
        .getElementsByTagName("body")[0]
        ?.setAttribute("data-theme", value);
      setCurrentTheme(value);
      onThemeChange?.(value);
    }
  };

  return (
    <div>
      <SelectField
        field={getThemeField(t)}
        value={currentTheme}
        onChange={handleChangeTheme}
      />
    </div>
  );
};

export default ThemeSelect;
